<template>
  <div class="ewmMask pa tac pr" v-if="visible">
    <h3 class="fw">联系技术专家 <i class="closeIcon f24 pa" @click="visible = false">×</i></h3>
    <p>
      <img :src="src" alt="">
    </p>
    <div class="btn">微信扫码二维码</div>
  </div>
</template>
<script>
import { getSupportInfo } from '../../requests/agreement'
export default {
  props: [],
  data () {
    return {
      visible: false,
      src: ''
    }
  },
  watch: {
    visible () {
      if (this.visible)
      {
        this.getSupportInfo()
      }
    }
  },
  mounted () {
    this.getSupportInfo()
  },
  methods: {
    async getSupportInfo () {
      let res = await getSupportInfo()
      if (res.code == 200)
      {
        this.src = res.data.wxQrUrl
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.ewmMask {

  background: #fff;
  border-radius: 10px;
  border: 1px solid #999;
  width: 210px;
  color: #0066cc;

  img {
    width: 120px;
    height: 120px;
    border: 1px solid #0066cc;
  }

  p {
    height: 120px;
  }

  h3 {
    line-height: 40px;
    margin-bottom: 10px;
  }

  .closeIcon {
    right: 10px;
  }

  .btn {
    width: 120px;
    line-height: 30px;
    border: 1px solid #999;
    display: inline-block;
    border-radius: 50px;
  }
}
</style>